import * as React from "react";
import type { SVGProps } from "react";
const SvgGavebillett = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 123.03 84.594"
    {...props}
  >
    <path
      d="M1267.78 323.794a19.5 19.5 0 0 0-3.24-5.109 1.22 1.22 0 0 0-1.56-.3 30.85 30.85 0 0 0-8.52 8.417 5.1 5.1 0 0 0-1.22-.456l-4.07-15.2 71.12-19.057 4.4 16.447Zm-30.78 1.557a1.16 1.16 0 0 0-1.18.951 19.3 19.3 0 0 0-.3 6.136l-18.95 5.077-4.41-16.447 33.16-8.884 4.08 15.209a5 5 0 0 0-.82.989 30.8 30.8 0 0 0-11.58-3.031m-19.39 16.034 18.75-5.025c.22.718.47 1.465.77 2.256a1.214 1.214 0 0 0 1.3.8 24.8 24.8 0 0 0 10.56-4.728 31.6 31.6 0 0 0-4.9 12.476.243.243 0 0 0 .34.264 28 28 0 0 1 3.69-1.464c.95.776 1.87 1.6 2.8 2.457a.231.231 0 0 0 .39-.144c.43-3.014.88-5.819 1.38-8.6l7.54 28.141-33.16 8.885-4.93-18.382-.39-1.452a8.012 8.012 0 0 0-4.14-15.484m44.99 3.9c.39-1.172.75-2.3 1.2-3.526 1.33-.239 2.62-.385 3.97-.55a.248.248 0 0 0 .17-.4c-2.83-3.716-6.52-6.171-10.57-8.371a24.04 24.04 0 0 0 11.4-1.154 1.185 1.185 0 0 0 .73-1.343c-.15-.831-.31-1.6-.49-2.332l56.72-15.2a8.013 8.013 0 0 0 4.15 15.479l.39 1.452 4.92 18.382-71.12 19.057-7.64-28.529c1.92 2.248 3.8 4.53 5.76 7.1a.231.231 0 0 0 .41-.062Z"
      style={{
        fill: "currentColor",
        fillRule: "evenodd",
      }}
      transform="translate(-1212.16 -292.094)"
    />
  </svg>
);
export default SvgGavebillett;
